import { c as _c } from "react/compiler-runtime";
import { Typography } from '@/components/Typography';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import type { FilterProps } from './types';
export function FilterDropdown(t0) {
  const $ = _c(20);
  const {
    items,
    selectedCount,
    title,
    toggle
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <span>{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== selectedCount) {
    t2 = selectedCount > 0 ? <span className="badge badge-primary w-5.5">{selectedCount}</span> : null;
    $[2] = selectedCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PhosphorIcon className="transition-transform duration-200 ease-out group-hover:rotate-180" name="caret-down" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <div className="btn btn-primary btn-outline pl-8 pr-7 border-primary gap-2 h-13" role="button" tabIndex={0}>{t1}{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== items || $[9] !== title || $[10] !== toggle) {
    let t6;
    if ($[12] !== title || $[13] !== toggle) {
      t6 = t7 => {
        const {
          isChecked,
          label
        } = t7;
        const itemId = `dropdown-${title}-${label}`;
        return <label htmlFor={itemId} className="flex flex-row gap-2 items-center cursor-pointer" key={itemId}><input checked={isChecked} className="checkbox !rounded-sm" type="checkbox" id={itemId} onChange={() => toggle(label)} /><Typography variant="paragraph" className="grow text-left text-nowrap font-bold">{label}</Typography></label>;
      };
      $[12] = title;
      $[13] = toggle;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = items.map(t6);
    $[8] = items;
    $[9] = title;
    $[10] = toggle;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <div className="dropdown-content menu bg-white rounded-2xl z-1 py-6 px-0 shadow-sm border-1 border-base-300 card-shadow" tabIndex={0}><div className="pl-6 pr-10 flex flex-col flex-nowrap max-h-[50vh] overflow-y-auto gap-4 w-full">{t5}</div></div>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <div className="dropdown dropdown-hover group">{t4}{t6}</div>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}